(function() {
  var userHasSelected = false;

  function clearSelection() {
    if (userHasSelected) return;

    document.querySelectorAll('.pl-variant-swatches__radio').forEach(function(input) {
      input.checked = false;
    });
    document.querySelectorAll('.pl-variant-swatches__swatch-wrapper--active').forEach(function(el) {
      el.classList.remove('pl-variant-swatches__swatch-wrapper--active');
    });
    document.querySelectorAll('product-variant-selects input[type="radio"]').forEach(function(input) {
      input.checked = false;
    });
    document.querySelectorAll('.is-active').forEach(function(el) {
      el.classList.remove('is-active');
    });
    document.querySelectorAll('[data-selected-value]').forEach(function(el) {
      el.textContent = '';
    });
    document.querySelectorAll('product-form').forEach(function(productForm) {
      var btn = productForm.querySelector('[type="submit"]');
      if (btn && !productForm._sizeSelectionInit) {
        btn.setAttribute('disabled', 'disabled');
        productForm._sizeSelectionInit = true;
      }
    });
  }

  function addClickListeners() {
    document.querySelectorAll('.pl-variant-swatches__container').forEach(function(container) {
      if (!container._listenerAdded) {
        container._listenerAdded = true;
        container.addEventListener('change', function() {
          userHasSelected = true;
          observer.disconnect();
          var productForm = document.querySelector('product-form');
          var btn = productForm?.querySelector('[type="submit"]');
          if (btn) btn.removeAttribute('disabled');
        });
      }
    });
  }

  var observer = new MutationObserver(function() {
    if (!userHasSelected) clearSelection();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('load', function() {
    clearSelection();
    addClickListeners();
    setTimeout(clearSelection, 300);
    setTimeout(clearSelection, 800);
    setTimeout(function() {
      if (!userHasSelected) observer.disconnect();
    }, 5000);
  });
})();
